// =====================================================================================
// INVRT Radar — web console — leaving the console for an external URL
//
// The ONE place this console sends the whole browser away from itself rather than through
// react-router — Stripe's own hosted checkout page is not part of this app. Kept as its own
// seam, rather than a bare `window.location.assign()` call inline, so a test can replace it
// directly instead of fighting jsdom's Location object (browser navigation is deliberately
// "not implemented" there).
// =====================================================================================

/** Leaves Radar for an external URL — today, always Stripe's hosted checkout page. */
export function redirectExternally(url: string): void {
  window.location.assign(url);
}
